import ContentsTypes from "@shared/enums/contentsTypes";
export const createButton = (text, url) => ({
    key: "dynamicElements",
    type: "BUTTON",
    value: "",
    children: [
        { key: "text", type: ContentsTypes.INPUT, value: text },
        { key: "color", type: "BUTTON_GROUP", value: "primary" },
        { key: "variant", type: "BUTTON_GROUP", value: "contained" },
        { key: "size", type: "BUTTON_GROUP", value: "large" },
        { key: "fullWidth", type: "CHECKBOX", value: "false" },
        { key: "justifyContent", type: "BUTTON_GROUP", value: "center" },
        {
            key: "link",
            type: ContentsTypes.LINK,
            value: "",
            children: [
                { key: "url", type: ContentsTypes.URL, value: url },
                { key: "page", type: "PAGE", value: "" },
                { key: "title", type: ContentsTypes.INPUT, value: "" },
                { key: "external", type: "CHECKBOX", value: "false" },
            ],
        },
        {
            key: "icon",
            type: ContentsTypes.ICON,
            value: "",
            children: [
                { key: "icon", type: ContentsTypes.INPUT, value: "long-arrow-right" },
                { key: "type", type: ContentsTypes.SELECT, value: "far" },
                { key: "color", type: ContentsTypes.COLOR, value: "#0000FF" },
                { key: "background", type: ContentsTypes.COLOR, value: "" },
            ],
        },
    ],
});
